import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import { Button } from '@mui/material'
import PrintIcon from '@mui/icons-material/Print'
import { useSelector } from 'react-redux'
import BaleTag from 'components/generic/printable/BaleTag'
import ConfirmationScreen from 'components/generic/confirmation-screen'
import PrintDialog from 'components/generic/printable/PrintDialog'
import { PRINT_DIALOG_TYPES, CHURN_ZERO_EVENTS as cz, MODAL_VIEW_MODES } from 'utils/constants'
import { trackEvent } from 'utils/tracking'
import { dateFormatter } from 'utils/data-manipulation/valueFormatter'

const FinishedGoodCreatedContainer = ({ onHideModal }) => {
  const navigate = useNavigate()
  const { finishedGood, navigateTo, viewMode } = useSelector(state => state.ui.formModalProps)
  const { enablePullApartFeatures } = useSelector(state => state.featureFlags?.variables || {})

  const [showPrintModal, setShowPrintModal] = useState(false)

  const handleOpenPrintDialog = () => setShowPrintModal(true)

  const handleClosePrintDialog = () => setShowPrintModal(false)

  const actionButtonList = () => (
    <>
      <Button variant="outlined" onClick={handleOpenPrintDialog} startIcon={<PrintIcon />}>
        Print Tag
      </Button>
      <Button
        onClick={() => {
          onHideModal()

          if (navigateTo) {
            navigate(navigateTo)
          }
        }}
        variant="contained"
      >
        Finish
      </Button>
    </>
  )
  const onAfterPrint = () => {
    trackEvent(cz.PRINT_BALE_TAGS)
  }

  const effectiveDate = dateFormatter(finishedGood?.effectiveDate)

  return (
    <>
      <ConfirmationScreen
        title={`Finished Good ${viewMode === MODAL_VIEW_MODES.EDIT ? 'Updated' : 'Created'}`}
        ActionButtonList={actionButtonList}
      />

      {showPrintModal && (
        <PrintDialog
          title={`#${finishedGood?.tag}${finishedGood?.purchaseOrderNumber ? `-${finishedGood?.purchaseOrderNumber}` : ''}`}
          open={showPrintModal}
          onClose={handleClosePrintDialog}
          dialogType={enablePullApartFeatures ? PRINT_DIALOG_TYPES.PULL_APART_TAG : PRINT_DIALOG_TYPES.TAG}
          onAfterPrint={onAfterPrint}
          showLogoAddress
        >
          <BaleTag
            createdDate={'Effective Date: ' + effectiveDate}
            materialName={finishedGood?.materialType?.commonName}
            gross={parseInt(finishedGood?.weight?.gross, 10)}
            tare={parseInt(finishedGood?.weight?.tare, 10)}
            net={parseInt(finishedGood?.weight?.net, 10)}
            qrCodeValue={finishedGood?.tag}
            notes={finishedGood?.notes && finishedGood?.notes.length > 0 ? finishedGood.notes[0].name : ''}
          />
        </PrintDialog>
      )}
    </>
  )
}

export default FinishedGoodCreatedContainer

FinishedGoodCreatedContainer.propTypes = {
  onHideModal: PropTypes.func,
}

FinishedGoodCreatedContainer.defaultProps = {
  onHideModal: () => {},
}
